import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'

export const ReaderSummaryHeader = () => {
  const { colors } = useTheme()

  return (
    <FlexBox
      className={css`
        gap: 2px;
      `}
      centerAll
    >
      <Text
        type="label"
        sizing="L"
        color={colors.uiWhite}
        align="center"
        weight="500"
      >
        Reader Summary
      </Text>
      <FlexBox
        className={css`
          width: 40px;
          height: 16px;
          border-radius: 24px;
          background-color: ${colors.uiWhite20};
        `}
        centerAll
      >
        <Text
          className={css`
            text-transform: uppercase;
            color: ${colors.uiWhite};
            font-size: 10px;
            letter-spacing: 0.5px;
          `}
          type="subhead"
          sizing="XS"
        >
          Beta
        </Text>
      </FlexBox>
    </FlexBox>
  )
}
